export enum E_KioskMode {
  Section = 'section',
  HibridSection = 'hibrid-section',
  Box = 'box',
  HibridBox = 'hibrid-box',
}